import React, { useState, useEffect, useRef } from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import Progressbar from 'components/common/Progressbar.jsx'
import fileDownload from 'js-file-download'

const LayoutSvgDownload = ( {  solution, type, svgParams, format, defaultFileName, multipleColumns} ) => {

  const [fileName, setFileName] = useState(defaultFileName);

  const [show, setShow] = useState(false);
  const [dt, setDt] = useState(true);
  const dtDisabled = type == "printing"
  const [pleaseWait, setPleaseWait] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setShow( () => true )
  }

  const icon_src = `https://d2atdwxjx7uc4i.cloudfront.net/images/${format}_logo.svg`;
  const icon = () => { return <img className={styles.download_icon} src={icon_src} onClick={handleClick} alt={t('models.download')} /> }

  const showRef = useRef();

  const showContent = () => {

    let beforeClose = () => {
      showRef.current.style.display = "none";
      setShow(() => false);
    };

    let onSuccess = () => {
      beforeClose();
    }

    const fileNameOnChange = (e) => {
      setFileName( () => e.target.value )
    }

    const fileNameWithExtension = () => {
      return fileName + "." + format;
    }

    const performDownload = (e) => {
      e.preventDefault();

      setPleaseWait( () => true )

      const url = `/layouts_nav_section_combination_download/${type}/${format}`
      const dataToPost = svgParams;
      dataToPost.authenticity_token = $('meta[name=csrf-token]').attr('content');
      dataToPost.dimension_texts_included = dt ? 'true' : 'false'
      dataToPost.file_name = fileName
      dataToPost.user_quote_id = window.user_quote_id;

      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToPost)
      };

      fetch(url, options)
        .then( res => res.blob() )
        .then( blob => {
          // emitEvent(Constants.drawing_download_finished, {id: id})
          fileDownload(blob, fileNameWithExtension())
          setPleaseWait( () => false )
          // refreshDownloadCounts();
          onSuccess();
        });
    }

    let content = pleaseWait ? <Progressbar /> : (
      <div className="testimonials-block preview-promo-block">
        <h3> Download </h3>
        <hr />
        <table className="table  ">
          <tbody>
            <tr>
              <td>
                <input disabled={dtDisabled} value="1" type="checkbox" checked={dt ? 'checked': ''} onChange={(e) => setDt(() => e.target.checked)} />
                &nbsp; {t('layouts.download_with_dimension_borders')}
              </td>
            </tr>

            <tr>
              <td>
                <div className="input-group">
                  <span className="input-group-addon"> { t('download_confirmation.file_name') } </span>
                  <input type="text" size="100" className="form-control" name="file_name" id="file_name" value={fileName} onChange={fileNameOnChange}/>
                  <span className="input-group-addon"><span id="file_extension"> .{format} </span> </span>
                </div>
              </td>
            </tr>

            <tr>
              <td> <hr /> <button className="simple-btn button btn btn-default" onClick={performDownload}> { t('download_confirmation.confirm') } </button> </td>
            </tr>

          </tbody>
        </table>
      </div>)

    return <ContentPopup contextClass="wrapper" myRef={showRef} autoOpen={true} content={content} cancelButton={false} beforeClose={beforeClose} notWide={true} />;

  }
  // useEffect
  useEffect( () => {
    // console.log( {solution} )
  } )
  // useEffect

  return (<>
    <button className="btn btn-default" onClick={handleClick}>
      {icon()} { !multipleColumns && <>&nbsp; {t('models.download')} </> }
    </button>
    {show && showContent()}
    </>
    )

}

export default LayoutSvgDownload;